/**
 * @flow
 * @relayHash 8318a4eb1e4a8900f26cca2138bd08e7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getAccountCreationDataQueryVariables = {|
  contractorToken: string,
  uidb64: string,
|};
export type getAccountCreationDataQueryResponse = {|
  +accountCreationTokenStatus: ?boolean
|};
export type getAccountCreationDataQuery = {|
  variables: getAccountCreationDataQueryVariables,
  response: getAccountCreationDataQueryResponse,
|};
*/


/*
query getAccountCreationDataQuery(
  $contractorToken: String!
  $uidb64: String!
) {
  accountCreationTokenStatus(contractorToken: $contractorToken, uidb64: $uidb64)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractorToken",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uidb64",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "accountCreationTokenStatus",
    "args": [
      {
        "kind": "Variable",
        "name": "contractorToken",
        "variableName": "contractorToken"
      },
      {
        "kind": "Variable",
        "name": "uidb64",
        "variableName": "uidb64"
      }
    ],
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getAccountCreationDataQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getAccountCreationDataQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getAccountCreationDataQuery",
    "id": null,
    "text": "query getAccountCreationDataQuery(\n  $contractorToken: String!\n  $uidb64: String!\n) {\n  accountCreationTokenStatus(contractorToken: $contractorToken, uidb64: $uidb64)\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e96fa0d8ed939b7841cc59efdb4e6fe3';
module.exports = node;
